import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { PosService } from "src/app/_services/posService";
import { PurchaseOrders } from "../../../_models/table-models";
declare var $: any;

import { formatDate } from "@angular/common";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { AuthenticationService } from "src/app/_app-core/services/authenticationService";
import { DialogServiceService } from "src/app/_app-core/dialogs/dialog-service.service";
import { DataExportService } from "src/app/_services/dataExportService";
import { PodService } from "src/app/_services/pod.service";
import { ImpersonationService } from "src/app/_app-core/services/impersonation/impersonation.service";

@Component({
  selector: "app-purchase-orders",
  templateUrl: "./purchase-orders.component.html",
  styleUrls: ["./purchase-orders.component.scss"],
})
export class PurchaseOrdersComponent implements OnInit {
  searchTerm: string = "";
  public isCollapsed = false;
  purchase_orders: PurchaseOrders[] = [];
  allPurchaseOrders: PurchaseOrders[] = [];
  responseData: any;
  poNo: any;
  isError: any;
  isEmpty = false;
  isSelected = false;
  displayName: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  pos: any;
  filterKey: any;
  loading = true;
  sessionExpired = false;
  errorMsg = "";
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  selectedOption = true;
  filterBy: any = "docNo";
  tableData: any;
  impersonate;
  poSelected = null;
  currentUserData: any;
  private searchSubject = new Subject<string>();

  // Server-side sort state. sortBy holds the API field name; sortOrder the
  // direction. Empty sortBy means "no explicit sort" (backend default order).
  sortBy = "";
  sortOrder: "asc" | "desc" = "asc";

  constructor(
    private router: Router,
    private authService: AuthService,
    private posService: PosService,
    private exportService: DataExportService,
    private cdref: ChangeDetectorRef,
    private authenticationService: AuthenticationService,
    private podService: PodService,
    private dialogService: DialogServiceService,
    @Inject(LOCALE_ID) public locale: string,
    public imp: ImpersonationService
  ) {}

  // Range of records currently shown, for the "Showing X–Y of Z entries" label.
  get showingStart(): number {
    return this.collectionSize ? (this.page - 1) * this.pageSize + 1 : 0;
  }

  get showingEnd(): number {
    return Math.min(this.page * this.pageSize, this.collectionSize || 0);
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onSelectChanges(event) {
    this.isSelected = event.target.checked;
  }

  sendPo(po = null) {
    this.dialogService
      .showConfirmDialog(
        `Create a Credit/Debit Note for PO ${this.poSelected?.docNo}? ` +
          `This is different from submitting an invoice — to submit an invoice, ` +
          `use the "Submit Invoice" button on the PO row.`
      )
      .then((confirmed) => {
        if (!confirmed) {
          return;
        }
        localStorage.setItem("pods", JSON.stringify([this.poSelected]));
        localStorage.setItem("selectionType", "po");
        if (po !== null) {
          console.log(po + " this is the null value");
        } else {
          localStorage.setItem("poType", this.poSelected.po_ses_mat);
          this.router.navigate(["/upload-credit-note", this.poSelected.docNo]);
        }
      })
      .catch(() => {
        /* dialog dismissed (ESC/backdrop) — treat as cancel */
      });
  }

  ngOnInit(): void {
    console.log("purchase orders");
    this.displayName = localStorage.getItem("displayName");

    if (localStorage.getItem("impersonation") === null || localStorage.getItem("impersonation") === "") {
      this.impersonate = "false";
    } else {
      this.impersonate = localStorage.getItem("impersonation") || false;
    }

    //console.log(this.impersonate);

    // Debounce typing in the search box so we hit the API once the user pauses,
    // instead of firing a request on every keystroke.
    this.searchSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term) => {
        this.searchTerm = term;
        this.page = 1;
        this.fetchPurchaseOrders();
      });

    this.fetchPurchaseOrders();
  }

  fetchPurchaseOrders() {
    this.loading = true;
    const userData = {
      supplierCode: localStorage.getItem("vendorCode"),
      docNo: this.filterBy === "docNo" ? this.searchTerm : undefined,
      // poNo: this.filterBy === "poNo" ? this.searchTerm : null,
      location: this.filterBy === "location" ? this.searchTerm : undefined,
      currCode: this.filterBy === "currCode" ? this.searchTerm : undefined,
      pageNo: this.page,
      pageSize: this.pageSize,
      // Server-side sort: only sent when the user has chosen a column.
      // NOTE: requires the backend to honour these params.
      sortBy: this.sortBy || undefined,
      sortOrder: this.sortBy ? this.sortOrder : undefined,
    };

    this.posService.fetchPurchaseOrderDetails(userData).subscribe(
      (res) => {
        console.log(res, "res");
        this.loading = false;
        this.responseData = res;

        if (this.responseData.code == 200) {
          this.purchase_orders = this.responseData.data.list;
          this.allPurchaseOrders = this.responseData.data.list;
          this.collectionSize =
            this.responseData.data.noOfRecords ??
            this.responseData.data.pagination?.totalPOs ??
            this.purchase_orders.length;
          // this.refreshPos();

          let sortedPos = this.purchase_orders.sort((a, b) => (a.creation_date > b.creation_date ? 1 : -1));
          const sellercode = localStorage.getItem("vendorCode");
          this.purchase_orders.forEach((po) => {
            po["inProcessInvoicedAmount"] = 0;
            po["canSubmitInvoice"] = sellercode == po["invoicingParty"]?.toString().trim();
            console.log(po["canSubmitInvoice"], "------------");
            po.location = po.barcodePrefix?.substring(2, 4);
          });
          this.pos = this.allPurchaseOrders;

          if (this.responseData.data.list.length === 0) {
            this.loading = false;
            this.isEmpty = true;
          } else {
            this.loading = false;
            this.isEmpty = false;
          }
        } else {
          this.loading = false;
        }
      },
      (error) => {
        console.log(error);
        this.loading = false;

        if (error.status === 401) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  accountLogout() {
    const userData = {
      session: { sessionId: localStorage.getItem("eippSession") },
    };
    this.authService.logOut(userData).subscribe(
      (res) => {
        const responseData: any = res;
        if (responseData.status === "ok") {
          localStorage.clear();
          this.router.navigateByUrl("/");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  refreshPos() {
    this.fetchPurchaseOrders();
  }

  // Header click → set the server-side sort field/direction and re-fetch.
  // Same column toggles direction; a new column starts ascending.
  onSort(field: string) {
    if (this.sortBy === field) {
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
    } else {
      this.sortBy = field;
      this.sortOrder = "asc";
    }
    this.page = 1;
    this.fetchPurchaseOrders();
  }

  // Chevron class for a sortable header: up/down when active, neutral otherwise.
  sortIconClass(field: string): string {
    if (this.sortBy !== field) {
      return "bi-chevron-expand";
    }
    return this.sortOrder === "asc" ? "bi-chevron-up" : "bi-chevron-down";
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    this.selectedOption = true;
  }

  onSearch(event: KeyboardEvent) {
    this.generalSearch(event);
  }

  generalSearch(event: KeyboardEvent) {
    // Push into the debounced stream; the actual fetch happens in ngOnInit's
    // subscription once the user stops typing.
    this.searchSubject.next((event.target as HTMLInputElement).value);

    // if (this.searchTerm !== "") {
    //     this.pos = this.allPurchaseOrders.filter(
    //         (data) =>
    //             (data.docNo as string)
    //                 .toLowerCase()
    //                 .includes(this.searchTerm.toLowerCase()) ||
    //             (data.currCode as string)
    //                 .toLowerCase()
    //                 .includes(this.searchTerm.toLowerCase())
    //     );
    // } else {
    //     this.pos = this.purchase_orders;
    // }
  }

  trackPoNumber(index: number, po: any) {
    return this.pos ? this.pos : undefined;
  }

  exportToExcel() {
    const date = new Date();

    const fileName = (this.displayName = localStorage.getItem("vendorCode")) + "_Purchase_Order_Table_" + formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

    if (this.selectedOption === false) {
      this.tableData = this.purchase_orders;
    } else {
      this.tableData = this.pos;
    }

    const cols = [
      {
        name: "PO No",
        colKey: "docNo",
      },
      {
        name: "PO Type",
        colKey: "po_ses_mat",
      },
      {
        name: "Location",
        colKey: "location",
      },
      {
        name: "PO Amount",
        colKey: "po_value",
      },
      {
        name: "Open PO Amount",
        colKey: "openPoValue",
      },
      {
        name: "Invoiced Amount",
        colKey: "invoicedAmount",
      },
      {
        name: "In-Process Invoice Amount",
        colKey: "inProcessInvoicedAmount",
      },
      {
        name: "PO Currency",
        colKey: "currCode",
      },
    ];

    this.exportService.exportToExcel(this.tableData, cols, fileName);
  }

  viewPoDetails(po: any) {
    this.podService.storePo(po);
    this.router.navigate(["/purchase-order-detail", po.docNo]);
  }

  submitPo(po: any) {
    this.dialogService
      .showConfirmDialog(`Submit a new invoice against PO ${po.docNo}?`)
      .then((confirmed) => {
        if (!confirmed) {
          return;
        }
        this.podService.storePo(po);
        this.router.navigate(["/proof-of-delivery", po._id]);
      })
      .catch(() => {
        /* dialog dismissed (ESC/backdrop) — treat as cancel */
      });
  }

  // Service (SERV) PO invoice submission — previously a direct routerLink.
  // Now guarded with the same confirmation as the material flow.
  submitServiceInvoice(po: any) {
    this.dialogService
      .showConfirmDialog(`Submit a new invoice against PO ${po.docNo}?`)
      .then((confirmed) => {
        if (!confirmed) {
          return;
        }
        this.router.navigate(["/po-line-items", po.docNo]);
      })
      .catch(() => {
        /* dialog dismissed (ESC/backdrop) — treat as cancel */
      });
  }

  details() {
    console.log(Date.now(), "Date.now()");
  }
}
